import {
  Alert,
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { COLOR_BACKGROUND_2, COLOR_ERROR_1, COLOR_ERROR_BACKGROUNG } from 'src/colors';
import CloseIcon from '@mui/icons-material/Close';
import { FullScreenCircularLoader, DynamicPricingLoader } from 'src/App/Components/Loaders';
import { CalendarDashboard, CompsetDashboard } from '../Dashboards/Pricing/Pages';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import theme from 'src/core/MuiThemeProvider/theme';
import {
  getProcessedDataForDynamicPricing,
  getnextNDates,
  processListingLevelData,
  processMarketLevelData,
} from 'src/utils/functions';

const classes = {
  tabName: {
    fontSize: 24,
    fontWeight: 500,
    cursor: 'pointer',
  },
  activeTabName: {
    fontSize: 24,
    fontWeight: 500,
    backgroundColor: '#C4C4C4',
    borderRadius: 10,
    padding: '10px 20px',
    cursor: 'pointer',
  },
};

const ManageListingModal = props => {
  const { open, onClose, listingPricingRecommendation } = props;
  const tabs = {
    calendar: 'Calendar',
    compset: 'Price Trends',
  };
  const [activeTab, setActiveTab] = useState<'calendar' | 'compset'>('compset');
  const [airbnbLoggedIn, setAirbnbLoggedIn] = useState(false);
  const manageListingModalContentRef = useRef(null);
  const matches = useMediaQuery(theme.breakpoints.down(900));
  const [noOfFutureDays, setNoOfFutureDays] = useState(365);

  const handleTimePeriodChange = event => {
    setNoOfFutureDays(event.target.value);
  };

  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box
        sx={{
          height: '95%',
          width: '95%',
          backgroundColor: COLOR_BACKGROUND_2,
          borderRadius: '20px',
          padding: '10px',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#555',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            height: '10%',
            // backgroundColor:'green'
          }}
        >
          <Button
            onClick={() => onClose(false)}
            sx={{ '&:hover': { backgroundColor: COLOR_BACKGROUND_2 } }}
          >
            <CloseIcon
              fontSize="large"
              sx={{
                height: '35px',
                width: '35px',
                color: COLOR_ERROR_1,
                borderRadius: '500px',
                '-webkit-color': COLOR_ERROR_1,
                '&:hover': {
                  backgroundColor: COLOR_ERROR_BACKGROUNG,
                  transition: 'background-color 0.3s ease-in-out',
                },
              }}
            />
          </Button>
        </Box>
        <Box
          ref={manageListingModalContentRef}
          sx={{
            overflowY: 'scroll',
            maxHeight: '90%',
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        >
          <Grid
            container
            item
            direction="column"
            spacing="2"
            // sx={{ backgroundColor:'yellow' }}
          >
            {listingPricingRecommendation && (
              <Grid
                container
                item
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{ padding: '0px 10px' }}
              >
                {Object.keys(tabs).map((tab, index) => (
                  <Grid item key={index}>
                    <Typography
                      sx={tab === activeTab ? classes.activeTabName : classes.tabName}
                      onClick={() => setActiveTab(tab as 'calendar' | 'compset')}
                    >
                      {tabs[tab]}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            )}
            {activeTab === 'compset' && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginRight: '5px',
                  position: 'relative',
                  top: '-60px',
                  height: 0,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 500,
                    marginBottom: '10px',
                    marginRight: '5px',
                    marginTop: '5px',
                  }}
                >
                  Time Period:
                </Typography>
                <FormControl>
                  <Select
                    value={noOfFutureDays}
                    onChange={handleTimePeriodChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    sx={{
                      width: '150px',
                      '& .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
                        padding: '10px',
                      },
                    }}
                  >
                    <MenuItem value={30}>Next 30 Days</MenuItem>
                    <MenuItem value={60}>Next 60 Days</MenuItem>
                    <MenuItem value={90}>Next 90 Days</MenuItem>
                    <MenuItem value={365}>Next 365 Days</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}

            {activeTab === 'calendar' && (
              <>
                {listingPricingRecommendation?.comp_listings_metadata ===
                'insufficient_listings' ? (
                  <Box>
                    <Alert severity="error">
                      Sorry, we can't find enough comps to analyze the data.
                    </Alert>
                  </Box>
                ) : (
                  <CalendarDashboard
                    listingPricingRecommendation={listingPricingRecommendation}
                    calendarListingID={listingPricingRecommendation.listing_details.listingID}
                    airbnbLoggedIn={airbnbLoggedIn}
                  />
                )}
              </>
            )}

            {activeTab === 'compset' && (
              <>
                {listingPricingRecommendation?.comp_listings_metadata ===
                'insufficient_listings' ? (
                  <Box>
                    <Alert severity="error">
                      Sorry, we can't find enough comps to analyze the data.
                    </Alert>
                  </Box>
                ) : (
                  <CompsetDashboard
                    listingPricingRecommendation={listingPricingRecommendation}
                    manageListingModalContentRef={manageListingModalContentRef}
                    noOfFutureDays={noOfFutureDays}
                  />
                )}
              </>
            )}
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default ManageListingModal;
